import { NavLink } from 'react-router-dom'
import { useUiStore } from '../../store/uiStore'

interface NavItem {
  to: string
  label: string
  icon: string
  end?: boolean
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: '▣', end: true },
  { to: '/cargas', label: 'Cargas', icon: '⛽' },
  { to: '/mapa', label: 'Mapa', icon: '🗺' },
  { to: '/outliers', label: 'Outliers', icon: '⚠' },
  { to: '/operadores', label: 'Operadores', icon: '👤' },
  { to: '/vehiculos', label: 'Vehículos', icon: '🚛' },
  { to: '/tanques', label: 'Tanques', icon: '🛢' },
  { to: '/geofences', label: 'Zonas de obra', icon: '🗺' },
  { to: '/reportes', label: 'Reportes', icon: '📊' },
  { to: '/settings', label: 'Configuración', icon: '⚙' },
]

export function Sidebar() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed)

  return (
    <aside
      className={[
        'flex flex-col bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-700',
        'transition-all duration-200 shrink-0',
        collapsed ? 'w-16' : 'w-56',
      ].join(' ')}
    >
      {/* Logo */}
      <div className="flex items-center gap-2 px-4 py-4 border-b border-slate-200 dark:border-slate-700 h-16">
        <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <span className="text-white text-xs font-bold">AF</span>
        </div>
        {!collapsed && (
          <span className="font-bold text-slate-900 dark:text-slate-100 text-sm">AuraFleet</span>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto p-2 space-y-0.5">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                'sidebar-link',
                isActive ? 'active' : '',
                collapsed ? 'justify-center' : '',
              ].join(' ')
            }
            title={collapsed ? item.label : undefined}
          >
            <span className="text-base leading-none">{item.icon}</span>
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Version */}
      {!collapsed && (
        <div className="px-4 py-3 text-xs text-slate-400 dark:text-slate-600 border-t border-slate-200 dark:border-slate-700">
          v0.1.0 — sem 1-2
        </div>
      )}
    </aside>
  )
}
